import * as configCat from 'configcat-js';

const configClient = configCat.getClient(process.env.VUE_APP_CONFIGCAT_SDK)

const isFlagActive = async (flag, event) => {
    const flagActive = await configClient.getValueAsync(flag, false);
    if (flagActive) event('flag', flag);
    return flagActive
}
export default isFlagActive